import { StackProps as StackPropsMui } from '@mui/material';
import { forwardRef } from 'react';
import { LayoutProps } from '../../utils/layout-spacing-props';
import { StyledStackMui } from './Stack.styles';

export interface StackProps
  extends Pick<StackPropsMui, 'children' | 'divider' | 'spacing' | 'direction'>,
    LayoutProps {
  readonly alignItems?: StackPropsMui['alignItems'];
}

export const Stack = forwardRef<HTMLDivElement, StackProps>((props, ref) => {
  return <StyledStackMui {...props} ref={ref} />;
});
